import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem } from 'reactstrap';
import { Context as AuthContext } from '../../contexts/AuthContext';
import UserService from '../../services/User';
import moment from 'moment';

type BaseNavBarNotificationItemProps = { item: any; insideDropdown?: boolean; onOpen?: () => void };

const BaseNavBarNotificationItem = ({ item, insideDropdown = true, onOpen }: BaseNavBarNotificationItemProps) => {
  const { token, updateUserNotifications }: any = useContext(AuthContext);

  const readNotification = async (notification: any) => {
    await UserService(token || '').readNotification({ id: [notification.id] });
    updateUserNotifications();
    if (notification.type === 'newHireApproval') {
      window.location.href = '/directory/approvals/new-hire';
    }
    if (notification.type === 'payRateChange') {
      if (notification.data?.description.endsWith('approval.')) {
        window.location.href = '/directory/approvals/raise';
      } else {
        window.location.href = `/users/${notification.userId}/profile/payrates`;
      }
    }
    if (notification.type === 'timeOffRequest') {
      window.location.href = '/pto/approvals';
    }
    if (notification.type === 'taskAssigned') {
      window.location.href = '/task-board';
    }
    if (notification.type === 'taskCommentTagged') {
      window.location.href = '/task-board';
    }
  };

  const getToUrl = (item: any) => {
    switch (item.type) {
      case 'newHireApproval':
        return '/directory/approvals/new-hire';
      case 'payRateChange':
        return '/directory/approvals/raise';
      case 'timeOffRequest':
        return '/pto/approvals';
      case 'employeeBirthdays':
        return '/directory';
      case 'paperWorkCompleted':
        return `/users/${item?.relatedId}/profile`;
      case 'webEnrollmentSubmitted':
        return item?.relatedId ? `/kids/${item.relatedId}` : '/home';
      case 'taskAssigned':
        return '/task-board';
      case 'taskCommentTagged':
        return '/task-board';
      default:
        return '/directory';
    }
  };
  return (
    <div key={`notification-list-${item?.id}`}>
      <DropdownItem
        to={getToUrl(item)}
        tag={Link}
        toggle={insideDropdown}
        onClick={() => {
          readNotification(item);
          onOpen?.();
        }}
        style={{
          width: '100%',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'break-spaces',
        }}
        key={`baseItem-${item?.id}`}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ flex: '0 0 auto', textAlign: 'center' }}>
            <img className="rounded-circle" style={{ width: 40, height: 40 }} src={item?.picture} alt={``} />
            <p className="text-center small mb-0" style={{ wordBreak: 'break-word' }}>
              <b>{item?.data?.name}</b>
            </p>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ wordBreak: 'break-word' }}>
              <b>{item?.data?.title}</b>
            </div>
            <div style={{ wordBreak: 'break-word' }}>{item?.data?.description}</div>
            <div style={{ textAlign: 'right', fontSize: '0.8em', color: '#888' }}>
              {item?.type === 'employeeBirthdays' ? 'Today' : moment(item?.data?.occurAt).utc().fromNow()}
            </div>
          </div>
        </div>
      </DropdownItem>
      <DropdownItem divider={true}></DropdownItem>
    </div>
  );
};

export default BaseNavBarNotificationItem;
